import { Pipe, PipeTransform } from '@angular/core';
import { LanguageService } from '../services/language.service';


@Pipe({
    name: 'language',
    standalone:true
})
export class LanguagePipe implements PipeTransform {
    constructor(private languageProvider: LanguageService) {

    }
    transform(defaultValue: string, translationProperty: string, languageCode: string, parameters?: string[]): string {
        let translated = this.languageProvider.getString(translationProperty, languageCode, parameters);
        if (!translated || typeof translated !== 'string')
            return defaultValue || translationProperty;
        return translated;
    }
    transformList(defaultValue: string[], translationProperty: string, languageCode: string, parameters?: string[]) {
        let translated = this.languageProvider.getString(translationProperty, languageCode, parameters);
        if (!translated)
            return translationProperty;
        return translated;
    }
}